/**
 * 环境检测工具模块
 * 提供浏览器类型、设备状态检测和 REM 单位初始化功能
 * 
 * @module common/utils/environment
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 确保命名空间存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.common) {
    global.watashi.common = {};
  }

  const common = global.watashi.common;

  /**
   * 判断浏览器类型和设备状态
   * @returns {Object} 包含浏览器类型和是否为移动设备的对象
   * @property {boolean} isMobile - 是否为移动设备
   * @property {Object} browser - 浏览器信息 {name, version}
   * @property {string} os - 操作系统
   * 
   * @example
   * const env = watashi.common.getClientEnvironment();
   * console.log(env.isMobile); // true/false
   * console.log(env.browser.name); // "chrome", "firefox", etc.
   * console.log(env.os); // "Android", "iOS", "Windows", etc.
   */
  common.getClientEnvironment = function () {
    const ua = navigator.userAgent;

    const result = {
      isMobile: false,
      browser: {
        name: 'unknown',
        version: '0'
      },
      os: 'Other'
    };

    // 检测是否为移动设备
    result.isMobile = (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) ||
      /AppleWebKit.*Mobile/i.test(ua) ||
      /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/i.test(ua)
    );

    // 检测浏览器名称和版本
    const browserMatch = ua.match(/(firefox|chrome|safari|opera|msie|trident(?=\/))?\/\s*([\d.]+)/i) || [];
    const browserName = browserMatch[1] || 'unknown';
    const browserVersion = browserMatch[2] || '0';
    result.browser = {
      name: browserName,
      version: browserVersion,
    };

    // 检测操作系统
    const operatingSystems = {
      'Windows Phone': /Windows Phone/i,
      'Android': /Android/i,
      'iOS': /iPad|iPhone|iPod/i,
      'Mac OS X': /Macintosh|Mac OS X/i,
      'Windows': /Windows/i,
      'Linux': /Linux/i
    };
    for (let key in operatingSystems) {
      if (operatingSystems[key].test(ua)) {
        result.os = key;
        break;
      }
    }

    return result;
  };

  /**
   * 检查元素是否存在
   * @param {string} selector - CSS选择器
   * @returns {boolean} 元素是否存在
   * 
   * @example
   * if (watashi.common.exists('#myElement')) {
   *   // 元素存在
   * }
   */
  common.exists = function (selector) {
    return !!document.querySelector(selector);
  };

  /**
   * 初始化REM单位（响应式字体大小）
   * @param {number} [baseFontSize=10] - 基础字体大小，默认为 10px
   * @param {number} [baseWidth=360] - 设计稿宽度，默认为 360px
   * 
   * @example
   * watashi.common.initRem(10, 360);
   */
  common.initRem = function (baseFontSize = 10, baseWidth = 360) {
    const html = document.documentElement;
    const width = html.clientWidth || document.body.clientWidth;
    const clientEnv = common.getClientEnvironment();

    // 移动端允许 width > baseWidth，等比例变化
    if (width < baseWidth || clientEnv.isMobile) {
      html.style.fontSize = baseFontSize * (width / baseWidth) + 'px';
    } else {
      html.style.fontSize = baseFontSize + 'px';
    }
  };

})(typeof window !== "undefined" ? window : this);
